<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" modal-size="large">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `leave-types/${inputs.id}` : `leave-types`'>
                <div class="row">
                    <div class="col-md-12">
                        <!-- Code Input -->
                        <div class="form-group">
                            <label for="code">{{ $t('code') }}</label>
                            <app-input id="code" type="text" v-model="inputs.code"
                                :placeholder="$t('code')"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Name Input -->
                        <div class="form-group">
                            <label for="name">{{ $t('name') }}</label>
                            <app-input id="name" type="text" v-model="inputs.name"
                                :placeholder="$t('name')" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Is Paid Leave Input -->
                        <div class="form-group">
                            <label for="is_paid_leave">{{ $t('is_paid_leave') }}</label>
                            <app-input id="is_paid_leave" type="radio" v-model="inputs.is_paid"
                                :list="list" :placeholder="$t('is_paid_leave')" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Max Days Input -->
                        <div class="form-group">
                            <label for="max_days">{{ $t('max_days_per_year') }}</label>
                            <app-input id="max_days" type="number" v-model="inputs.max_days_per_year"
                                :placeholder="$t('max_days_per_year')"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Description Input -->
                        <div class="form-group">
                            <label for="description">{{ $t('description') }}</label>
                            <app-input id="description" type="text" v-model="inputs.description"
                                :placeholder="$t('description')" :required="true" />
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';

export default {
    name: 'LeaveTypeAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {

    },
    data() {
        return {
            preloader: false,
            modalId: 'leave-type-add-edit-modal',
            inputs: {
                name: '',
                description: '',
            },
            isModalActive: false,
            modalTitle: `${this.$t('new-leave-type')}`,
            list: [
                {
                    id: '1',
                    value: this.$t('yes')
                },
                {
                    id: '0',
                    value: this.$t('no')
                },
            ],
        }
    },
    methods: {
        submit() {
            this.save(this.inputs);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.preloader = false;
        },
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>